var _path, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightLeaves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 274,
    viewBox: "0 0 328 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "right-leaves_svg__mask0_613_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 328,
    height: 274
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 0H0v274h328V0z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#right-leaves_svg__mask0_613_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.956-4.018C97.64 29.267 145.371 56.31 204.588 59.596c37.782 2.162 75.571-4.893 108.59-20.272-23.277 24.58-37.159 54.212-39.888 85.142-4.21 46.232 18.722 88.042 51.67 120.861 1.604 1.513 3.135 3.078 4.729 4.583l5.479 5.173 18.33-13.013a183.248 183.248 0 007.088-5.28c33.951-26.538 57.424-63.426 61.116-104.06 3.911-43.048-28.556-97.277-60.234-127.56l-.123-.116c-32.189-30.021-93.077-63.956-145.717-66.884-50.783-2.833-99.767 11.692-136.94 36.423L55.636-9.041l5.32 5.023zm344.182 137.799c-.088-.083 0 0 0 0z",
    fill: "#fff"
  }))));
}
export default SvgRightLeaves;